<template>
  <div id="app" :class="['app-wrapper', { 'mobile-open': mobileMenuOpen }]">
    <AppHeader @toggle-menu="toggleMobileMenu" />
    <main class="main-content">
      <router-view />
    </main>
    <AppFooter />
    <InquiryFloat />
    <MobileMenu
      :visible="mobileMenuOpen"
      @close="mobileMenuOpen = false"
    />
  </div>
</template>

<script>
import AppHeader from '@/components/layout/AppHeader.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import InquiryFloat from '@/components/common/InquiryFloat.vue'
import MobileMenu from '@/components/layout/MobileMenu.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    InquiryFloat,
    MobileMenu
  },
  data() {
    return {
      mobileMenuOpen: false
    }
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    }
  },
  watch: {
    '$route'() {
      this.mobileMenuOpen = false
    }
  }
}
</script>

<style lang="less">
.app-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #F0F4F8;
}

.main-content {
  flex: 1;
  padding-top: 64px;

  @media (max-width: 767px) {
    padding-top: 56px;
  }
}
</style>
